import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false
Vue.use(ElementUI);
import * as voicePromptFun from "./untils/voicePrompt";
//zng.bvy.cc
Vue.prototype.voicePrompt = voicePromptFun.voicePrompt; //语音提醒
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
